var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "collection-gifting-page" }, [
    !_vm.isMobile() && (this.currentStep > 0 || _vm.selectedCollection)
      ? _c(
          "div",
          { staticClass: "gifting-header" },
          [
            _vm._l(_vm.steps, function(step, i) {
              return _c(
                "div",
                {
                  key: step,
                  staticClass: "header-step",
                  class: _vm.currentStep == i ? "current" : ""
                },
                [
                  _c("p", { staticClass: "title" }, [_vm._v(_vm._s(step))]),
                  _vm._v(" "),
                  _c("p", { staticClass: "circle" })
                ]
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "header-line" })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isMobile() && (this.currentStep > 0 || _vm.selectedCollection)
      ? _c("div", { staticClass: "gifting-header" }, [
          _c("div", { staticClass: "header-step current" }, [
            _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.actualStep))]),
            _vm._v(" "),
            _c("p", { staticClass: "circle" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "header-line" })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "gifting-container" },
      [
        _vm.currentStep == 0 && !_vm.selectedCollection
          ? _c("BudgetSelection", { on: { selecttop: _vm.selectTop } })
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep == 0 && _vm.selectedCollection
          ? _c("CollectionDescription", { on: { changepage: _vm.changePage } })
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep == 1
          ? _c("EmailSelection", { on: { changepage: _vm.changePage } })
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep == 2
          ? _c("EmailConfiguration", { on: { changepage: _vm.changePage } })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }